import React, { useRef } from 'react'
import { reduxForm } from 'redux-form';
import { Modal, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import parse from 'html-react-parser';
import ReactToPrint from 'react-to-print';
import download from "../../../assets/images/dv.svg";

const PackingSlip = props => {
    const { show, onHide, previewPackingSlipText, boqProductData, boqProductDataAllData } = props;
    const componentRef = useRef();

    return (
        <>
            <Modal
                show={show}
                size="lg"
                onHide={() => {
                    onHide();
                }}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <div className="modal-staff">
                    <div className="head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <i class="fas fa-arrow-left" onClick={() => {
                                onHide();
                            }}></i>
                            <h4>PACKING SLIP</h4>
                        </div>
                        <div>
                            <p>Invoice No : <b>{boqProductDataAllData?.data?.invoiceNumber}</b></p>
                            <ReactToPrint
                                trigger={() => <img style={{ cursor: "pointer" }} src={download} alt="" />}
                                content={() => componentRef.current}
                            />
                        </div>
                    </div>
                    {previewPackingSlipText !== "" && <Row className="preview-img" style={{ display: "none" }}>
                        <div className="template-two-design" ref={componentRef} dangerouslySetInnerHTML={{ __html: `${previewPackingSlipText}` }} />
                    </Row>}
                    <div className="table-class" style={{ padding: "20px" }}>
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        Product Name
                                    </th>
                                    <th scope="col" style={{ textAlign: "center" }}>
                                        No. of Box
                                    </th>
                                    <th scope="col" style={{ textAlign: "center" }}>
                                        Qty.
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    boqProductData?.packingSlipResDtoList && boqProductData?.packingSlipResDtoList.map((item, i) => (
                                        <tr key={i} >
                                            <td>
                                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {parse(item.productName || "-")}</Tooltip>}>
                                                    <span
                                                        className="d-inline-block"
                                                        style={{
                                                            width: "450px",
                                                            display: "inline-block",
                                                            whiteSpace: "nowrap", // or "nowrap" if you want a single line
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}
                                                    >
                                                        {parse(item.productName || "-")}
                                                    </span>
                                                </OverlayTrigger>
                                            </td>
                                            <td style={{ textAlign: "center" }}>{item?.noOfBox}</td>
                                            <td style={{ textAlign: "center" }}>{item?.quantity}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </Modal>

        </>
    )
}

function mapStateToProps(state) {
    return {
        boqProductData: state.boq.boqProductData,
        boqProductDataAllData: state.boq.boqProductDataAllData,
        previewPackingSlipText: state.boq.previewPackingSlipText
    }
}

const Form = reduxForm({
    form: "PackingSlip",
    destroyOnUnmount: false,
    enableReinitialize: true,
    // validate
})(PackingSlip);

export default connect(mapStateToProps)(Form);
